import { Box } from 'braid-design-system';

export const TruncateText = ({ children }: { children: React.ReactNode }) => (
  <Box
    style={{
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    }}
  >
    {children}
  </Box>
);
